import angular from 'angular';
import controller from './repre.controller';
import template from './repre.html';
import fbtemplate from './builder/preview.html';
import RepreComponent from './repre.component';

const repreConfig = /* @ngInject */ (/** @type {any} */ KformComponentsProvider) => {
	KformComponentsProvider.register('repre', {
		title:                         'Repre',
		template,
		fbtemplate,
		group:                         'advanced',
		children:                      false,
		selectable:                    true,
		settings:                      new RepreComponent(),
		validate:                      {
			rules: {},
		},
		event:                         {
			onChange: undefined,
		},
		icon:                          'fa fa-i-cursor',
		noDndOverlay:                  true,
		confirmRemove:                 true,
		views:                         [
			{
				name:     'Display',
				template: 'kform/components/repre/display.html',
			},
			{
				name:     'Validation',
				template: 'kform/components/repre/validate.html',
			},
			{
				name:     'API',
				template: 'kform/components/repre/api.html',
			},
			{
				name:     'Conditional',
				template: 'kform/components/common/conditional.html',
			},
			{
				name:     'Events',
				template: 'kform/components/common/events.html',
			},
		],
		controller,
	});
};

export default angular.module('app')
	.config(repreConfig);
